export const FILTER_QUERY_DATE_FORMAT = 'YYYY-MM-DD'
export const DISPLAY_DATE_SHORT_FORMAT = 'MM/DD/YY'
export const DISPLAY_DATE_FORMAT = 'MM/DD/YYYY'
export const DISPLAY_DATE_TIME_FORMAT = 'MM/DD/YY, hh:mm A'
export const DATE_FORMAT = 'MMMM DD, YYYY'
export const TIME_FORMAT = 'hh:mm A'
export const TIME_FORMAT_24H = 'HH:mm'
